"use client";

import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import Coordonnees from "../../components/Coordonnees";
import ContactMessages from "../../components/ContactMessages";
import Breadcrumbs from "../../components/Breadcrumbs.jsx";

export default function ContactClient() {
  const [msgEnvoye] = useState("");
  const [msgError] = useState("");

  return (
    <div className=" mx-10 px-4 my-10">
      <div>
        <main id="main">
          <Breadcrumbs currentPage="Contact" />

          <h1 className="text-4xl mt-5 mb-10 flex items-center">
            <FontAwesomeIcon
              icon={faEnvelope}
              className="w-12 h-12 p-2 mr-2 ml-0"
            />
            Contact Développeur Web
          </h1>

          <ContactMessages msgEnvoye={msgEnvoye} msgError={msgError} />

          <div className="container m-auto">
            <Coordonnees />
          </div>
        </main>
      </div>
    </div>
  );
}
